import buttonDefaultSchema from '../../formComponents/button/defaultSchema';
import columnDefaultSchema from '../../formComponents/columns/columnsDefaultSchema';
import datetimeDefaultSchema from '../../formComponents/datetime/defaultSchema';
import fileDefaultSchema from '../../formComponents/file/fileDefaultSchema';
import numberDefaultSchema from '../../formComponents/number/defaultSchema';
import selectDefaultSchema from '../../formComponents/select/defaultSchema';
import textareaDefaultSchema from '../../formComponents/textarea/defaultSchema';
import textFieldDefaultSchema from '../../formComponents/textfield/defaultSchema';
import htmlElementDefaultSchema from '../../formComponents/htmlelement/defaultSchema';
import checkboxDefaultSchema from '../../formComponents/checkbox/defaultSchema';

/**
 * Components implemented in formways
 */
const defaultFormwaysSchema = {
  'fw-button': buttonDefaultSchema,
  'fw-column': columnDefaultSchema,
  'fw-datetime': datetimeDefaultSchema,
  'fw-file': fileDefaultSchema,
  'fw-number': numberDefaultSchema,
  'fw-select': selectDefaultSchema,
  'fw-textarea': textareaDefaultSchema,
  'fw-textfield': textFieldDefaultSchema,
  'fw-htmlelement': htmlElementDefaultSchema,
  'fw-checkbox': checkboxDefaultSchema
};

/**
 * Converts different forms of default values in formio schema to
 * standardised formways schema
 * @param {Object} component
 * @returns {Object}
 */
const processDefaultValue = component => {
  if (component.defaultValue && component.defaultValue.type === 'customScript') {
    component.customDefaultValue = component.defaultValue.script;
    delete component.defaultValue;
  } else if (component.defaultValue && component.defaultValue.type === 'url') {
    component.allowDefaultValueURL = true;
    component.defaultValueURL = component.defaultValue.url;
    delete component.defaultValue;
  } else if (component.defaultValue) {
    component.defaultValue = component.defaultValue.value;
  }
  // TODO: handle default value loaded using url
};

/**
 * removes the unnecessary props and formats the default value properly
 * @param {*} component
 * @param {*} defaultSchema
 */
const processDefaultValueAndRemoveUnnecessaryProps = (component, defaultSchema) => {
  const schema = { ...defaultSchema, ...component };
  processDefaultValue(schema);
  schema.type = schema.type.slice(3); // remove 'fw-' form the component name
  return schema;
};

/**
 * Converts a formio component to json which is compatible with formways
 * @param {Object} component
 * @returns Object
 */
export const formwaysToformioComponent = component => {
  if (component.type in defaultFormwaysSchema) {
    return processDefaultValueAndRemoveUnnecessaryProps(
      component,
      defaultFormwaysSchema[component.type]
    );
  }
  return component;
};

const formwaysToFormio = form => {
  const formioComponents = [];
  // cloning the components to avoid reference issues
  const formwaysComponents = [...form.components];
  formwaysComponents.forEach(component => {
    if (component.type === 'fw-columns') {
      const columns = [];
      component.columns.forEach(column => {
        columns.push(formwaysToFormio(column));
      });
      // eslint-disable-next-line
      component.columns = columns;
      // eslint-disable-next-line
      component.type = component.type.slice(3);
      formioComponents.push(component);
    } else {
      formioComponents.push(formwaysToformioComponent(component));
    }
  });
  const formioSchema = { ...form };
  formioSchema.components = formioComponents;
  return formioSchema;
};

export default formwaysToFormio;
